export const HOME = 'home'
export const CAREERS = 'careers'
export const PRESS = 'press'
export const CONTACT = 'contact'
export const PRODUCTS = 'products'
